<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  // name: 'App',
  // 刷新后返回首页
    // mounted:function(){
    //         this.$router.push('/');
    //     }
}
</script>

<style>

</style>
